module.exports = __webpack_public_path__ + "img/gw.637d1146.jpg";